import { cn } from '@/lib/cn';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import Image from 'next/image';

const BADGE_ICON_SIZE = 46;

interface CompliantLogoBadgeProps {
  iconSrc: string;
  alt: string;
  text: string;
  className?: string;
}

function CompliantLogoBadge({ iconSrc, alt, text, className }: CompliantLogoBadgeProps) {
  return (
    <div
      className={cn(
        'flex h-[70px] w-[189px] shrink-0 flex-col items-start gap-2.5 rounded-lg bg-surface px-4 py-3 shadow-xl',
        className
      )}
      data-testid="compliance-badge"
    >
      <div className="flex items-center gap-2">
        <Image src={iconSrc} alt={alt} width={BADGE_ICON_SIZE} height={BADGE_ICON_SIZE} />
        <TypographyP2Bold>{text}</TypographyP2Bold>
      </div>
    </div>
  );
}

export { CompliantLogoBadge };
